import kanjiVariants from './kanjiVariants';

// Alt+Shift+V cycles the selected character through its known kanji variants, in any text input/textarea
function handleKeydown(event) {
    if (event.key.toLowerCase() !== 'v' || !event.shiftKey || event.ctrlKey || !event.altKey) {
        return;
    }

    const target = event.target;
    // Only input types that support selectionStart/selectionEnd (e.g. not email/number)
    const textInputTypes = ['text', 'search', 'tel', 'url', 'password'];
    const isTextInput = target && (target.tagName === 'TEXTAREA' || (target.tagName === 'INPUT' && (!target.type || textInputTypes.includes(target.type))));

    if (!isTextInput) {
        return;
    }

    let start, end;
    try {
        start = target.selectionStart;
        end = target.selectionEnd;
    } catch (e) {
        return;
    }

    if (start == null || end == null) {
        return;
    }

    const selectedText = target.value.substring(start, end);

    // Allow up to 3 code units for variation selectors/combining characters
    if (!selectedText || selectedText.length === 0 || selectedText.length > 3) {
        return;
    }

    for (const pair of kanjiVariants) {
        if (!pair.includes(selectedText)) {
            continue;
        }

        const newChar = pair[(pair.indexOf(selectedText) + 1) % pair.length];

        target.value = target.value.substring(0, start) + newChar + target.value.substring(end);

        // Dispatch native input so Vue's v-model updates immediately
        try {
            target.dispatchEvent(new InputEvent('input', { bubbles: true }));
        } catch (e) {
            // Fallback for older browsers
            target.dispatchEvent(new Event('input', { bubbles: true }));
        }

        // Defer dispatching the `change` event until the input is blurred so
        // any @change handlers run on blur only, like a manual edit would.
        const onBlurDispatchChange = function onBlurDispatchChange() {
            try {
                target.dispatchEvent(new Event('change', { bubbles: true }));
            } finally {
                target.removeEventListener('blur', onBlurDispatchChange);
            }
        };

        target.addEventListener('blur', onBlurDispatchChange);

        // Reselect the character (accounting for potential length differences)
        setTimeout(() => {
            target.focus();
            target.setSelectionRange(start, start + newChar.length);
        }, 20);
        break;
    }
}

// Call once at app startup to enable the shortcut app-wide
export function setupKanjiVariantToggle() {
    document.addEventListener('keydown', handleKeydown);
}
